import { Directive, ElementRef, HostBinding } from '@angular/core';

@Directive({
    selector: '[evkMatBody1]'
})
export class MatBody1Directive {

    @HostBinding('class')
    public class = 'mat-body-1';

}
